// Module
var code = "<modal title=\"{{ $ctrl.title || ('Please wait' | translate) }}\" hide-footer=\"true\" hide-close=\"true\"> {{ $ctrl.message }} </modal> ";
// Exports
module.exports = code;